export const containsEmptyValues = (value: any): boolean => {
  // If Array, loop through each item and feed it to this function
  if (Array.isArray(value)) {
    const r = value.map(containsEmptyValues);
    return r.includes(true);
  }
  // If Object, loop through values and feed it to this function
  // NOTE: This is somewhat naive as Functions etc are also "objects" in JS.
  if (typeof value === "object") {
    const r = Object.values(value).map(containsEmptyValues);
    return r.includes(true);
  }
  // If Primitive, test string length
  return typeof value === "string" && value.length === 0;
};
